import { ChainId } from '@donaswap/sdk'
import { NetworkAlertChains } from './ShouldShowAlert'

export const BG_COLORS_BY_DARK_MODE_AND_CHAIN_ID: {
  [isDark in 'light' | 'dark' | 'fire']: { [chainId in NetworkAlertChains]: string }
} = {
  light: {
    [ChainId.FIRECHAIN]: '#FFFFFF',
    [ChainId.RINIA]: '#FFFFFF',
    [ChainId.FIRECHAIN_ZKEVM]: '#FFFFFF',
    [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: '#FFFFFF',
    [ChainId.ETHEREUM]: '#FFFFFF',
    [ChainId.GOERLI]: '#FFFFFF',
    [ChainId.SEPOLIA]: '#FFFFFF',
    [ChainId.HOLESKY]: '#FFFFFF',
    [ChainId.BSC]: '#FFFFFF',
    [ChainId.BSC_TESTNET]: '#FFFFFF',
    [ChainId.POLYGON]: '#FFFFFF',
    [ChainId.POLYGON_AMOY]: '#FFFFFF',
    [ChainId.POLYGON_ZKEVM]: '#FFFFFF',
    [ChainId.POLYGON_ZKEVM_TESTNET]: '#FFFFFF',
    [ChainId.CRO]: '#FFFFFF',
    [ChainId.CRO_TESTNET]: '#FFFFFF',
    [ChainId.AVALANCHE]: '#FFFFFF',
    [ChainId.AVALANCHE_FUJI]: '#FFFFFF',
    [ChainId.FANTOM_OPERA]: '#FFFFFF',
    [ChainId.FANTOM_TESTNET]: '#FFFFFF',
    [ChainId.CELO]: '#FFFFFF',
    [ChainId.CELO_ALFAJORES]: '#FFFFFF',
    [ChainId.OPTIMISM]: '#FFFFFF',
    [ChainId.OPTIMISM_GOERLI]: '#FFFFFF',
    [ChainId.ARBITRUM_ONE]: '#FFFFFF',
    [ChainId.ARBITRUM_GOERLI]: '#FFFFFF',
    [ChainId.SHIBARIUM]: 'radial-gradient(circle, rgba(255,165,2, 0) 10%, rgba(255,165,2, 0.09) 60%)',
    [ChainId.SHIBARIUM_TESTNET]: 'radial-gradient(circle, rgba(255,165,2, 0) 10%, rgba(255,165,2, 0.09) 60%)',
    [ChainId.PULSECHAIN]: '#FFFFFF',
    [ChainId.PULSECHAIN_TESTNET]: '#FFFFFF',
    [ChainId.XEN]: '#FFFFFF',
    [ChainId.XEN_DEVNET]: '#FFFFFF',
    [ChainId.HARMONY]: '#FFFFFF',
    [ChainId.HARMONY_TESTNET]: '#FFFFFF',
    [ChainId.COINEX]: '#FFFFFF',
    [ChainId.COINEX_TESTNET]: '#FFFFFF',
    [ChainId.DOGECHAIN]: '#FFFFFF',
    [ChainId.DOGECHAIN_TESTNET]: '#FFFFFF',
    [ChainId.ENGRAM_TESTNET]: '#FFFFFF',
    [ChainId.ETHEREUM_CLASSIC]: 'radial-gradient(circle, rgba(46,132,46, 0) 10%, rgba(46,132,46, 0.09) 60%)',
    [ChainId.ETHEREUM_CLASSIC_TESTNET]: 'radial-gradient(circle, rgba(46,132,46, 0) 10%, rgba(46,132,46, 0.09) 60%)',
    [ChainId.FUSION]: '#FFFFFF',
    [ChainId.FUSION_TESTNET]: '#FFFFFF',
    [ChainId.HECO]: '#FFFFFF',
    [ChainId.HECO_TESTNET]: '#FFFFFF',
    [ChainId.KCC]: '#FFFFFF',
    [ChainId.KCC_TESTNET]: '#FFFFFF',
    [ChainId.KLAYTN]: '#FFFFFF',
    [ChainId.KLAYTN_BAOBAB]: '#FFFFFF',
    [ChainId.OKXCHAIN]: '#FFFFFF',
    [ChainId.OKXCHAIN_TESTNET]: '#FFFFFF',
    [ChainId.THETHA]: 'radial-gradient(circle, rgba(37,185,231, 0) 10%, rgba(37,185,231, 0.09) 60%)',
    [ChainId.THETHA_TESTNET]: 'radial-gradient(circle, rgba(37,185,231, 0) 10%, rgba(37,185,231, 0.09) 60%)',
    [ChainId.ULTRON]: '#FFFFFF',
    [ChainId.ULTRON_TESTNET]: '#FFFFFF',
    [ChainId.MOONBEAM]: '#FFFFFF',
    [ChainId.MOONBASE_ALPHA]: '#FFFFFF',
    [ChainId.MOONRIVER]: '#FFFFFF',
    [ChainId.AURORA]: '#FFFFFF',
    [ChainId.AURORA_TESTNET]: '#FFFFFF',
    [ChainId.BOBA]: '#FFFFFF',
    [ChainId.BOBA_GOERLI]: '#FFFFFF',
    [ChainId.GNOSIS]: '#FFFFFF',
    [ChainId.GNOSIS_CHIADO]: '#FFFFFF',
    [ChainId.METIS]: '#FFFFFF',
    [ChainId.METIS_GOERLI]: '#FFFFFF',
    [ChainId.TELOS]: '#FFFFFF',
    [ChainId.TELOS_TESTNET]: '#FFFFFF',
    [ChainId.SYSCOIN]: 'radial-gradient(circle, rgba(31,94,255, 0) 10%, rgba(231,94,255, 0.09) 60%)',
    [ChainId.SYSCOIN_TANENBAUM]: 'radial-gradient(circle, rgba(231,94,255, 0) 10%, rgba(231,94,255, 0.09) 60%)',
    [ChainId.IOTEX]: 'radial-gradient(circle, rgba(0,212,213, 0) 10%, rgba(0,212,213, 0.09) 60%)',
    [ChainId.IOTEX_TESTNET]: 'radial-gradient(circle, rgba(0,212,213, 0) 10%, rgba(0,212,213, 0.09) 60%)',
    [ChainId.SHIDEN]: '#FFFFFF',
    [ChainId.SHIBUNYA]: '#FFFFFF',
    [ChainId.ASTAR]: '#FFFFFF',
    [ChainId.FUSE]: '#FFFFFF',
    [ChainId.FUSE_SPARKNET]: '#FFFFFF',
    [ChainId.VELAS]: 'radial-gradient(circle, rgba(0,55,193, 0) 10%, rgba(0,55,193, 0.09) 60%)',
    [ChainId.VELAS_TESTNET]: 'radial-gradient(circle, rgba(0,55,193, 0) 10%, rgba(0,55,193, 0.09) 60%)',
    [ChainId.REI]: 'radial-gradient(circle, rgba(33,22,229, 0) 10%, rgba(33,22,229, 0.09) 60%)',
    [ChainId.REI_TESTNET]: 'radial-gradient(circle, rgba(33,22,229, 0) 10%, rgba(33,22,229, 0.09) 60%)',
    [ChainId.KEKCHAIN]: 'radial-gradient(circle, rgba(24,120,60, 0) 10%, rgba(24,120,60, 0.09) 60%)',
    [ChainId.KEKCHAIN_TESTNET]: 'radial-gradient(circle, rgba(24,120,60, 0) 10%, rgba(24,120,60, 0.09) 60%)',
    [ChainId.TOMOCHAIN]: '#FFFFFF',
    [ChainId.TOMOCHAIN_TESTNET]: '#FFFFFF',
    [ChainId.THUNDERCORE]: '#FFFFFF',
    [ChainId.THUNDERCORE_TESTNET]: '#FFFFFF',
    [ChainId.WANCHAIN]: 'radial-gradient(circle, rgba(19,106,173, 0) 10%, rgba(19,106,173, 0.09) 60%)',
    [ChainId.WANCHAIN_TESTNET]: 'radial-gradient(circle, rgba(19,106,173, 0) 10%, rgba(19,106,173, 0.09) 60%)',
    [ChainId.RSK]: '#FFFFFF',
    [ChainId.RSK_TESTNET]: '#FFFFFF',
    [ChainId.ELASTOS]: '#FFFFFF',
    [ChainId.ELASTOS_TESTNET]: '#FFFFFF',
    [ChainId.CONFLUX]: '#FFFFFF',
    [ChainId.CONFLUX_TESTNET]: '#FFFFFF',
    [ChainId.BRISECHAIN]: '#FFFFFF',
    [ChainId.BRISECHAIN_TESTNET]: '#FFFFFF',
    [ChainId.MUUCHAIN]: 'radial-gradient(circle, rgba(45,63,189, 0) 10%, rgba(45,63,189, 0.09) 60%)',
    [ChainId.MUUCHAIN_TESTNET]: 'radial-gradient(circle, rgba(45,63,189, 0) 10%, rgba(45,63,189, 0.09) 60%)',
    [ChainId.CANTO]: 'radial-gradient(circle, rgba(6,252,153, 0) 10%, rgba(6,252,153, 0.09) 60%)',
    [ChainId.CANTO_TESTNET]: 'radial-gradient(circle, rgba(6,252,153, 0) 10%, rgba(6,252,153, 0.09) 60%)',
    [ChainId.OASIS_EMERALD]: 'radial-gradient(circle, rgba(0,137,219, 0) 10%, rgba(0,137,219, 0.09) 60%)',
    [ChainId.OASIS_TESTNET]: 'radial-gradient(circle, rgba(0,137,219, 0) 10%, rgba(0,137,219, 0.09) 60%)',
    [ChainId.VISION]: 'radial-gradient(circle, rgba(255, 255, 255, 0) 10%, rgba(255, 255, 255, 0.09) 60%)',
    [ChainId.VISION_TESTNET]: 'radial-gradient(circle, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0.09) 80%)',
    [ChainId.STEP]: 'radial-gradient(circle, rgba(249,213,73, 0) 10%, rgba(249,213,73, 0.09) 60%)',
    [ChainId.STEP_TESTNET]: 'radial-gradient(circle, rgba(249,213,73, 0) 10%, rgba(249,213,73, 0.09) 60%)',
    [ChainId.METER]: 'radial-gradient(circle, rgba(2,135,208, 0) 10%, rgba(2,135,208, 0.09) 60%)',
    [ChainId.METER_TESTNET]: 'radial-gradient(circle, rgba(2,135,208, 0) 10%, rgba(2,135,208, 0.09) 60%)',
    [ChainId.GODWOKEN]: '#FFFFFF',
    [ChainId.GODWOKEN_TESTNET]: '#FFFFFF',
    [ChainId.CALLISTO]: 'radial-gradient(circle, rgba(33,174,84, 0) 10%, rgba(33,174,84, 0.09) 60%)',
    [ChainId.CALLISTO_TESTNET]: 'radial-gradient(circle, rgba(33,174,84, 0) 10%, rgba(33,174,84, 0.09) 60%)',
    [ChainId.EVMOS]: 'radial-gradient(circle, rgba(237,78,51, 0) 10%, rgba(237,78,51, 0.09) 60%)',
    [ChainId.EVMOS_TESTNET]: 'radial-gradient(circle, rgba(237,78,51, 0) 10%, rgba(237,78,51, 0.09) 60%)',
    [ChainId.ENERGY_WEB_CHAIN]: 'radial-gradient(circle, rgba(165,102,255, 0) 10%, rgba(165,102,255, 0.09) 60%)',
    [ChainId.ENERGY_VOLTA]: 'radial-gradient(circle, rgba(165,102,255, 0) 10%, rgba(165,102,255, 0.09) 60%)',
    [ChainId.BASE]: '#FFFFFF',
    [ChainId.BASE_GOERLI]: '#FFFFFF',
    [ChainId.KAVA]: '#FFFFFF',
    [ChainId.KAVA_TESTNET]: '#FFFFFF',
    [ChainId.CLOVER]: '#FFFFFF',
    [ChainId.CLOVER_TESTNET]: '#FFFFFF',
    [ChainId.DEFICHAIN]: '#FFFFFF',
    [ChainId.DEFICHAIN_TESTNET]: '#FFFFFF',
    [ChainId.BRONOS]: '#FFFFFF',
    [ChainId.BRONOS_TESTNET]: '#FFFFFF',
    [ChainId.FILECOIN]: '#FFFFFF',
    [ChainId.FILECOIN_CALIBRATION]: '#FFFFFF',
    [ChainId.FLARE]: '#FFFFFF',
    [ChainId.FLARE_TESTNET]: '#FFFFFF',
    [ChainId.TARAXA]: 'radial-gradient(circle, rgba(13,174,91, 0) 10%, rgba(13,174,91, 0.09) 60%)',
    [ChainId.TARAXA_TESTNET]: 'radial-gradient(circle, rgba(13,174,91, 0) 10%, rgba(13,174,91, 0.09) 60%)',
    [ChainId.ZKSYNC]: '#FFFFFF',
    [ChainId.ZKSYNC_TESTNET]: '#FFFFFF',
    [ChainId.LINEA]: '#FFFFFF',
    [ChainId.LINEA_TESTNET]: '#FFFFFF',
    [ChainId.BTTCHAIN]: '#FFFFFF',
    [ChainId.BTTCHAIN_TESTNET]: '#FFFFFF',
    [ChainId.BOBA_AVAX]: '#FFFFFF',
    [ChainId.BOBA_BNB]: '#FFFFFF',
    [ChainId.CMP]: '#FFFFFF',
    [ChainId.CMP_TESTNET]: '#FFFFFF',
    [ChainId.CORE]: '#FFFFFF',
    [ChainId.CORE_TESTNET]: '#FFFFFF',
    [ChainId.CUBECHAIN]: '#FFFFFF',
    [ChainId.CUBECHAIN_TESTNET]: '#FFFFFF',
    [ChainId.DARWINIA_CRAB]: '#FFFFFF',
    [ChainId.DARWINIA_PANGOLIN]: '#FFFFFF',
    [ChainId.DIODE_PRETNET]: '#FFFFFF',
    [ChainId.DIODE_TESTNET]: '#FFFFFF',
    [ChainId.GOCHAIN]: '#FFFFFF',
    [ChainId.GOCHAIN_TESTNET]: '#FFFFFF',
    [ChainId.HAQQ]: '#FFFFFF',
    [ChainId.HAQQ_TESTEDGE2]: '#FFFFFF',
    [ChainId.KARDIACHAIN]: '#FFFFFF',
    [ChainId.KARDIACHAIN_TESTNET]: '#FFFFFF',
    [ChainId.METADIUM]: '#FFFFFF',
    [ChainId.METADIUM_TESTNET]: '#FFFFFF',
    [ChainId.OP_BNB]: '#FFFFFF',
    [ChainId.OP_BNB_TESTNET]: '#FFFFFF',
    [ChainId.PALM]: '#FFFFFF',
    [ChainId.PALM_TESTNET]: '#FFFFFF',
    [ChainId.POLIS]: '#FFFFFF',
    [ChainId.POLIS_TESTNET]: '#FFFFFF',
    [ChainId.SHIBACHAIN]: '#FFFFFF',
    [ChainId.SMART_BCH]: '#FFFFFF',
    [ChainId.SMART_BCH_TESTNET]: '#FFFFFF',
    [ChainId.SONGBIRD_CANARY]: '#FFFFFF',
    [ChainId.THAICHAIN]: '#FFFFFF',
    [ChainId.UBIQ]: '#FFFFFF',
    [ChainId.UBIQ_TESTNET]: '#FFFFFF',
    [ChainId.VECHAIN]: '#FFFFFF',
    [ChainId.VECHAIN_TESTNET]: '#FFFFFF',
    [ChainId.XINFIN]: 'radial-gradient(circle, rgba(36, 75, 129, 0) 10%, rgba(36, 75, 129, 0.09) 60%)',
    [ChainId.XINFIN_APOTHEM]: 'radial-gradient(circle, rgba(36, 75, 129, 0) 10%, rgba(36, 75, 129, 0.09) 60%)',
    [ChainId.SCROLL]: '#FFFFFF',
    [ChainId.SCROLL_SEPOLIA]: '#FFFFFF',
    [ChainId.XRPL_DEVNET]: '#FFFFFF',
    [ChainId.ZETACHAIN]: '#FFFFFF',
    [ChainId.ZETACHAIN_ATHENS]: '#FFFFFF',
    [ChainId.ZYX]: '#FFFFFF',
  },
  dark: {
    [ChainId.FIRECHAIN]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.RINIA]: 'rgba(135, 142, 149, 0.19)',
    [ChainId.FIRECHAIN_ZKEVM]: 'rgba(98,127,235, 0.19)',
    [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: 'rgba(98,127,235, 0.19)',
    [ChainId.ETHEREUM]: 'rgba(98,127,235, 0.19)',
    [ChainId.GOERLI]: 'rgba(98,127,235, 0.19)',
    [ChainId.SEPOLIA]: 'rgba(98,127,235, 0.19)',
    [ChainId.HOLESKY]: 'rgba(98,127,235, 0.19)',
    [ChainId.BSC]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.BSC_TESTNET]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.POLYGON]: 'rgba(130,71,229, 0.19)',
    [ChainId.POLYGON_AMOY]: 'rgba(130,71,229, 0.19)',
    [ChainId.POLYGON_ZKEVM]: 'rgba(130,71,229, 0.19)',
    [ChainId.POLYGON_ZKEVM_TESTNET]: 'rgba(130,71,229, 0.19)',
    [ChainId.CRO]: 'rgba(236,51,103, 0.19)',
    [ChainId.CRO_TESTNET]: 'rgba(36,51,103, 0.19)',
    [ChainId.AVALANCHE]: 'rgba(232,65,66, 0.19)',
    [ChainId.AVALANCHE_FUJI]: 'rgba(232,65,66, 0.19)',
    [ChainId.FANTOM_OPERA]: 'rgba(19,181,236, 0.19)',
    [ChainId.FANTOM_TESTNET]: 'rgba(19,181,236, 0.19)',
    [ChainId.CELO]: 'rgba(53,208,127, 0.19)',
    [ChainId.CELO_ALFAJORES]: 'rgba(53,208,127, 0.19)',
    [ChainId.OPTIMISM]: 'rgba(255,4,32, 0.19)',
    [ChainId.OPTIMISM_GOERLI]: 'rgba(255,4,32, 0.19)',
    [ChainId.ARBITRUM_ONE]: 'rgba(40,160,240, 0.19)',
    [ChainId.ARBITRUM_GOERLI]: 'rgba(40,160,240, 0.19)',
    [ChainId.SHIBARIUM]: 'rgba(255,165,2, 0.19)',
    [ChainId.SHIBARIUM_TESTNET]: 'rgba(255,165,2, 0.19)',
    [ChainId.PULSECHAIN]: 'rgba(124,0,255, 0.19)',
    [ChainId.PULSECHAIN_TESTNET]: 'rgba(124,0,255, 0.19)',
    [ChainId.XEN]: 'rgba(0,0,0, 0.19)',
    [ChainId.XEN_DEVNET]: 'rgba(0,0,0, 0.19)',
    [ChainId.HARMONY]: 'rgba(46,207,214, 0.19)',
    [ChainId.HARMONY_TESTNET]: 'rgba(46,207,214, 0.19)',
    [ChainId.COINEX]: 'rgba(78,78,255, 0.19)',
    [ChainId.COINEX_TESTNET]: 'rgba(78,78,255, 0.19)',
    [ChainId.DOGECHAIN]: 'rgba(146,85,250, 0.19)',
    [ChainId.DOGECHAIN_TESTNET]: 'rgba(146,85,250, 0.19)',
    [ChainId.ENGRAM_TESTNET]: 'rgba(146,85,250, 0.19)',
    [ChainId.ETHEREUM_CLASSIC]: 'rgba(46,132,46, 0.19)',
    [ChainId.ETHEREUM_CLASSIC_TESTNET]: 'rgba(46,132,46, 0.19)',
    [ChainId.FUSION]: 'rgba(18,46,90, 0.19)',
    [ChainId.FUSION_TESTNET]: 'rgba(18,46,90, 0.19)',
    [ChainId.HECO]: 'rgba(49,173,88, 0.19)',
    [ChainId.HECO_TESTNET]: 'rgba(49,173,88, 0.19)',
    [ChainId.KCC]: 'rgba(62,230,175, 0.19)',
    [ChainId.KCC_TESTNET]: 'rgba(62,230,175, 0.19)',
    [ChainId.KLAYTN]: 'rgba(168,1,6, 0.19)',
    [ChainId.KLAYTN_BAOBAB]: 'rgba(168,1,6, 0.19)',
    [ChainId.OKXCHAIN]: 'rgba(0,0,0, 0.19)',
    [ChainId.OKXCHAIN_TESTNET]: 'rgba(0,0,0, 0.19)',
    [ChainId.THETHA]: 'rgba(37,185,231, 0.19)',
    [ChainId.THETHA_TESTNET]: 'rgba(37,185,231, 0.19)',
    [ChainId.ULTRON]: 'rgba(62,9,162, 0.19)',
    [ChainId.ULTRON_TESTNET]: 'rgba(62,9,162, 0.19)',
    [ChainId.MOONBEAM]: 'rgba(23,30,67, 0.19)',
    [ChainId.MOONBASE_ALPHA]: 'rgba(23,30,67, 0.19)',
    [ChainId.MOONRIVER]: 'rgba(243,183,5, 0.19)',
    [ChainId.AURORA]: 'rgba(110,211,74, 0.19)',
    [ChainId.AURORA_TESTNET]: 'rgba(110,211,74, 0.19)',
    [ChainId.BOBA]: 'rgba(28,216,210, 0.19)',
    [ChainId.BOBA_GOERLI]: 'rgba(28,216,210, 0.19)',
    [ChainId.GNOSIS]: 'rgba(0,25,60, 0.19)',
    [ChainId.GNOSIS_CHIADO]: 'rgba(0,25,60, 0.19)',
    [ChainId.METIS]: 'rgba(0,207,194, 0.19)',
    [ChainId.METIS_GOERLI]: 'rgba(0,207,194, 0.19)',
    [ChainId.TELOS]: 'rgba(109,75,184, 0.19)',
    [ChainId.TELOS_TESTNET]: 'rgba(109,75,184, 0.19)',
    [ChainId.SYSCOIN]: 'rgba(231,94,255, 0.19)',
    [ChainId.SYSCOIN_TANENBAUM]: 'rgba(231,94,255, 0.19)',
    [ChainId.IOTEX]: 'rgba(0,212,213, 0.19)',
    [ChainId.IOTEX_TESTNET]: 'rgba(0,212,213, 0.19)',
    [ChainId.SHIDEN]: 'rgba(175,104,255, 0.19)',
    [ChainId.SHIBUNYA]: 'rgba(175,104,255, 0.19)',
    [ChainId.ASTAR]: 'rgba(0,119,238, 0.19)',
    [ChainId.FUSE]: 'rgba(184,252,164, 0.19)',
    [ChainId.FUSE_SPARKNET]: 'rgba(184,252,164, 0.19)',
    [ChainId.VELAS]: 'rgba(0,55,193, 0.19)',
    [ChainId.VELAS_TESTNET]: 'rgba(0,55,193, 0.19)',
    [ChainId.REI]: 'rgba(33,22,229, 0.19)',
    [ChainId.REI_TESTNET]: 'rgba(33,22,229, 0.19)',
    [ChainId.KEKCHAIN]: 'rgba(24,120,60, 0.19)',
    [ChainId.KEKCHAIN_TESTNET]: 'rgba(24,120,60, 0.19)',
    [ChainId.TOMOCHAIN]: 'rgba(0,233,180, 0.19)',
    [ChainId.TOMOCHAIN_TESTNET]: 'rgba(0,233,180, 0.19)',
    [ChainId.THUNDERCORE]: 'rgba(0,214,233, 0.19)',
    [ChainId.THUNDERCORE_TESTNET]: 'rgba(0,214,233, 0.19)',
    [ChainId.WANCHAIN]: 'rgba(19,106,173, 0.19)',
    [ChainId.WANCHAIN_TESTNET]: 'rgba(19,106,173, 0.19)',
    [ChainId.RSK]: 'rgba(79,123,61, 0.19)',
    [ChainId.RSK_TESTNET]: 'rgba(79,123,61, 0.19)',
    [ChainId.ELASTOS]: 'rgba(42,61,88, 0.19)',
    [ChainId.ELASTOS_TESTNET]: 'rgba(42,61,88, 0.19)',
    [ChainId.CONFLUX]: 'rgba(31,144,155, 0.19)',
    [ChainId.CONFLUX_TESTNET]: 'rgba(31,144,155, 0.19)',
    [ChainId.BRISECHAIN]: 'rgba(99,12,229, 0.19)',
    [ChainId.BRISECHAIN_TESTNET]: 'rgba(99,12,229, 0.19)',
    [ChainId.MUUCHAIN]: 'rgba(45,63,189, 0.19)',
    [ChainId.MUUCHAIN_TESTNET]: 'rgba(45,63,189, 0.19)',
    [ChainId.CANTO]: 'rgba(6,252,153, 0.19)',
    [ChainId.CANTO_TESTNET]: 'rgba(6,252,153, 0.19)',
    [ChainId.OASIS_EMERALD]: 'rgba(0,137,219, 0.19)',
    [ChainId.OASIS_TESTNET]: 'rgba(0,137,219, 0.19)',
    [ChainId.VISION]: 'rgba(255, 255, 255, 0.19)',
    [ChainId.VISION_TESTNET]: 'rgba(0, 0, 0, 0.19) 80%)',
    [ChainId.STEP]: 'rgba(249,213,73, 0.19)',
    [ChainId.STEP_TESTNET]: 'rgba(249,213,73, 0.19)',
    [ChainId.METER]: 'rgba(2,135,208, 0.19)',
    [ChainId.METER_TESTNET]: 'rgba(2,135,208, 0.19)',
    [ChainId.GODWOKEN]: 'rgba(0,205,158, 0.19)',
    [ChainId.GODWOKEN_TESTNET]: 'rgba(0,205,158, 0.19)',
    [ChainId.CALLISTO]: 'rgba(33,174,84, 0.19)',
    [ChainId.CALLISTO_TESTNET]: 'rgba(33,174,84, 0.19)',
    [ChainId.EVMOS]: 'rgba(237,78,51, 0.19)',
    [ChainId.EVMOS_TESTNET]: 'rgba(237,78,51, 0.19)',
    [ChainId.ENERGY_WEB_CHAIN]: 'rgba(165,102,255, 0.19)',
    [ChainId.ENERGY_VOLTA]: 'rgba(165,102,255, 0.19)',
    [ChainId.BASE]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BASE_GOERLI]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.KAVA]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.KAVA_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CLOVER]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CLOVER_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DEFICHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DEFICHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BRONOS]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BRONOS_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FILECOIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FILECOIN_CALIBRATION]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FLARE]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FLARE_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.TARAXA]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.TARAXA_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZKSYNC]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZKSYNC_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.LINEA]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.LINEA_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BTTCHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BTTCHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BOBA_AVAX]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BOBA_BNB]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CMP]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CMP_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CORE]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CORE_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CUBECHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CUBECHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DARWINIA_CRAB]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DARWINIA_PANGOLIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DIODE_PRETNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DIODE_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.GOCHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.GOCHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.HAQQ]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.HAQQ_TESTEDGE2]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.KARDIACHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.KARDIACHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.METADIUM]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.METADIUM_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.OP_BNB]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.OP_BNB_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.PALM]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.PALM_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.POLIS]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.POLIS_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.SHIBACHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.SMART_BCH]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.SMART_BCH_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.SONGBIRD_CANARY]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.THAICHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.UBIQ]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.UBIQ_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.VECHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.VECHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.XINFIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.XINFIN_APOTHEM]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.SCROLL]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.SCROLL_SEPOLIA]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.XRPL_DEVNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZETACHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZETACHAIN_ATHENS]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZYX]: 'rgba(0, 82, 255, 0.19)',
  },
  fire: {
    [ChainId.FIRECHAIN]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.RINIA]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.FIRECHAIN_ZKEVM]: 'rgba(98,127,235, 0.19)',
    [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: 'rgba(98,127,235, 0.19)',
    [ChainId.ETHEREUM]: 'rgba(98,127,235, 0.19)',
    [ChainId.GOERLI]: 'rgba(98,127,235, 0.19)',
    [ChainId.SEPOLIA]: 'rgba(98,127,235, 0.19)',
    [ChainId.HOLESKY]: 'rgba(98,127,235, 0.19)',
    [ChainId.BSC]: '#000000',
    [ChainId.BSC_TESTNET]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.POLYGON]: 'rgba(130,71,229, 0.19)',
    [ChainId.POLYGON_AMOY]: 'rgba(130,71,229, 0.19)',
    [ChainId.POLYGON_ZKEVM]: 'rgba(130,71,229, 0.19)',
    [ChainId.POLYGON_ZKEVM_TESTNET]: 'rgba(130,71,229, 0.19)',
    [ChainId.CRO]: 'rgba(236,51,103, 0.19)',
    [ChainId.CRO_TESTNET]: 'rgba(36,51,103, 0.19)',
    [ChainId.AVALANCHE]: 'rgba(232,65,66, 0.19)',
    [ChainId.AVALANCHE_FUJI]: 'rgba(232,65,66, 0.19)',
    [ChainId.FANTOM_OPERA]: 'rgba(19,181,236, 0.19)',
    [ChainId.FANTOM_TESTNET]: 'rgba(19,181,236, 0.19)',
    [ChainId.CELO]: 'rgba(53,208,127, 0.19)',
    [ChainId.CELO_ALFAJORES]: 'rgba(53,208,127, 0.19)',
    [ChainId.OPTIMISM]: 'rgba(255,4,32, 0.19)',
    [ChainId.OPTIMISM_GOERLI]: 'rgba(255,4,32, 0.19)',
    [ChainId.ARBITRUM_ONE]: 'rgba(40,160,240, 0.19)',
    [ChainId.ARBITRUM_GOERLI]: 'rgba(40,160,240, 0.19)',
    [ChainId.SHIBARIUM]: 'rgba(255,165,2, 0.19)',
    [ChainId.SHIBARIUM_TESTNET]: 'rgba(255,165,2, 0.19)',
    [ChainId.PULSECHAIN]: 'rgba(124,0,255, 0.19)',
    [ChainId.PULSECHAIN_TESTNET]: 'rgba(124,0,255, 0.19)',
    [ChainId.XEN]: 'rgba(0,0,0, 0.19)',
    [ChainId.XEN_DEVNET]: 'rgba(0,0,0, 0.19)',
    [ChainId.HARMONY]: 'rgba(46,207,214, 0.19)',
    [ChainId.HARMONY_TESTNET]: 'rgba(46,207,214, 0.19)',
    [ChainId.COINEX]: 'rgba(78,78,255, 0.19)',
    [ChainId.COINEX_TESTNET]: 'rgba(78,78,255, 0.19)',
    [ChainId.DOGECHAIN]: 'rgba(146,85,250, 0.19)',
    [ChainId.DOGECHAIN_TESTNET]: 'rgba(146,85,250, 0.19)',
    [ChainId.ENGRAM_TESTNET]: 'rgba(146,85,250, 0.19)',
    [ChainId.ETHEREUM_CLASSIC]: 'rgba(46,132,46, 0.19)',
    [ChainId.ETHEREUM_CLASSIC_TESTNET]: 'rgba(46,132,46, 0.19)',
    [ChainId.FUSION]: 'rgba(18,46,90, 0.19)',
    [ChainId.FUSION_TESTNET]: 'rgba(18,46,90, 0.19)',
    [ChainId.HECO]: 'rgba(49,173,88, 0.19)',
    [ChainId.HECO_TESTNET]: 'rgba(49,173,88, 0.19)',
    [ChainId.KCC]: 'rgba(62,230,175, 0.19)',
    [ChainId.KCC_TESTNET]: 'rgba(62,230,175, 0.19)',
    [ChainId.KLAYTN]: 'rgba(168,1,6, 0.19)',
    [ChainId.KLAYTN_BAOBAB]: 'rgba(168,1,6, 0.19)',
    [ChainId.OKXCHAIN]: 'rgba(0,0,0, 0.19)',
    [ChainId.OKXCHAIN_TESTNET]: 'rgba(0,0,0, 0.19)',
    [ChainId.THETHA]: 'rgba(37,185,231, 0.19)',
    [ChainId.THETHA_TESTNET]: 'rgba(37,185,231, 0.19)',
    [ChainId.ULTRON]: 'rgba(62,9,162, 0.19)',
    [ChainId.ULTRON_TESTNET]: 'rgba(62,9,162, 0.19)',
    [ChainId.MOONBEAM]: 'rgba(23,30,67, 0.19)',
    [ChainId.MOONBASE_ALPHA]: 'rgba(23,30,67, 0.19)',
    [ChainId.MOONRIVER]: 'rgba(243,183,5, 0.19)',
    [ChainId.AURORA]: 'rgba(110,211,74, 0.19)',
    [ChainId.AURORA_TESTNET]: 'rgba(110,211,74, 0.19)',
    [ChainId.BOBA]: 'rgba(28,216,210, 0.19)',
    [ChainId.BOBA_GOERLI]: 'rgba(28,216,210, 0.19)',
    [ChainId.GNOSIS]: 'rgba(0,25,60, 0.19)',
    [ChainId.GNOSIS_CHIADO]: 'rgba(0,25,60, 0.19)',
    [ChainId.METIS]: 'rgba(0,207,194, 0.19)',
    [ChainId.METIS_GOERLI]: 'rgba(0,207,194, 0.19)',
    [ChainId.TELOS]: 'rgba(109,75,184, 0.19)',
    [ChainId.TELOS_TESTNET]: 'rgba(109,75,184, 0.19)',
    [ChainId.SYSCOIN]: 'rgba(231,94,255, 0.19)',
    [ChainId.SYSCOIN_TANENBAUM]: 'rgba(231,94,255, 0.19)',
    [ChainId.IOTEX]: 'rgba(0,212,213, 0.19)',
    [ChainId.IOTEX_TESTNET]: 'rgba(0,212,213, 0.19)',
    [ChainId.SHIDEN]: 'rgba(175,104,255, 0.19)',
    [ChainId.SHIBUNYA]: 'rgba(175,104,255, 0.19)',
    [ChainId.ASTAR]: 'rgba(0,119,238, 0.19)',
    [ChainId.FUSE]: 'rgba(184,252,164, 0.19)',
    [ChainId.FUSE_SPARKNET]: 'rgba(184,252,164, 0.19)',
    [ChainId.VELAS]: 'rgba(0,55,193, 0.19)',
    [ChainId.VELAS_TESTNET]: 'rgba(0,55,193, 0.19)',
    [ChainId.REI]: 'rgba(33,22,229, 0.19)',
    [ChainId.REI_TESTNET]: 'rgba(33,22,229, 0.19)',
    [ChainId.KEKCHAIN]: 'rgba(24,120,60, 0.19)',
    [ChainId.KEKCHAIN_TESTNET]: 'rgba(24,120,60, 0.19)',
    [ChainId.TOMOCHAIN]: 'rgba(0,233,180, 0.19)',
    [ChainId.TOMOCHAIN_TESTNET]: 'rgba(0,233,180, 0.19)',
    [ChainId.THUNDERCORE]: 'rgba(0,214,233, 0.19)',
    [ChainId.THUNDERCORE_TESTNET]: 'rgba(0,214,233, 0.19)',
    [ChainId.WANCHAIN]: 'rgba(19,106,173, 0.19)',
    [ChainId.WANCHAIN_TESTNET]: 'rgba(19,106,173, 0.19)',
    [ChainId.RSK]: 'rgba(79,123,61, 0.19)',
    [ChainId.RSK_TESTNET]: 'rgba(79,123,61, 0.19)',
    [ChainId.ELASTOS]: 'rgba(42,61,88, 0.19)',
    [ChainId.ELASTOS_TESTNET]: 'rgba(42,61,88, 0.19)',
    [ChainId.CONFLUX]: 'rgba(31,144,155, 0.19)',
    [ChainId.CONFLUX_TESTNET]: 'rgba(31,144,155, 0.19)',
    [ChainId.BRISECHAIN]: 'rgba(99,12,229, 0.19)',
    [ChainId.BRISECHAIN_TESTNET]: 'rgba(99,12,229, 0.19)',
    [ChainId.MUUCHAIN]: 'rgba(45,63,189, 0.19)',
    [ChainId.MUUCHAIN_TESTNET]: 'rgba(45,63,189, 0.19)',
    [ChainId.CANTO]: 'rgba(6,252,153, 0.19)',
    [ChainId.CANTO_TESTNET]: 'rgba(6,252,153, 0.19)',
    [ChainId.OASIS_EMERALD]: 'rgba(0,137,219, 0.19)',
    [ChainId.OASIS_TESTNET]: 'rgba(0,137,219, 0.19)',
    [ChainId.VISION]: 'rgba(255, 255, 255, 0.19)',
    [ChainId.VISION_TESTNET]: 'rgba(0, 0, 0, 0.19) 80%)',
    [ChainId.STEP]: 'rgba(249,213,73, 0.19)',
    [ChainId.STEP_TESTNET]: 'rgba(249,213,73, 0.19)',
    [ChainId.METER]: 'rgba(2,135,208, 0.19)',
    [ChainId.METER_TESTNET]: 'rgba(2,135,208, 0.19)',
    [ChainId.GODWOKEN]: 'rgba(0,205,158, 0.19)',
    [ChainId.GODWOKEN_TESTNET]: 'rgba(0,205,158, 0.19)',
    [ChainId.CALLISTO]: 'rgba(33,174,84, 0.19)',
    [ChainId.CALLISTO_TESTNET]: 'rgba(33,174,84, 0.19)',
    [ChainId.EVMOS]: 'rgba(237,78,51, 0.19)',
    [ChainId.EVMOS_TESTNET]: 'rgba(237,78,51, 0.19)',
    [ChainId.ENERGY_WEB_CHAIN]: 'rgba(165,102,255, 0.19)',
    [ChainId.ENERGY_VOLTA]: 'rgba(165,102,255, 0.19)',
    [ChainId.BASE]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BASE_GOERLI]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.KAVA]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.KAVA_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CLOVER]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CLOVER_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DEFICHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DEFICHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BRONOS]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BRONOS_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FILECOIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FILECOIN_CALIBRATION]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FLARE]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FLARE_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.TARAXA]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.TARAXA_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZKSYNC]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZKSYNC_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.LINEA]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.LINEA_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BTTCHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BTTCHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BOBA_AVAX]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BOBA_BNB]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CMP]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CMP_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CORE]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CORE_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CUBECHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CUBECHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DARWINIA_CRAB]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DARWINIA_PANGOLIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DIODE_PRETNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DIODE_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.GOCHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.GOCHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.HAQQ]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.HAQQ_TESTEDGE2]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.KARDIACHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.KARDIACHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.METADIUM]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.METADIUM_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.OP_BNB]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.OP_BNB_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.PALM]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.PALM_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.POLIS]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.POLIS_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.SHIBACHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.SMART_BCH]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.SMART_BCH_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.SONGBIRD_CANARY]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.THAICHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.UBIQ]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.UBIQ_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.VECHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.VECHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.XINFIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.XINFIN_APOTHEM]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.SCROLL]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.SCROLL_SEPOLIA]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.XRPL_DEVNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZETACHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZETACHAIN_ATHENS]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZYX]: 'rgba(0, 82, 255, 0.19)',
  },
}
